import React from "react";
interface MobileAppWebViewLayoutProps {
    page: any;
}
export const MobileAppWebViewLayout = ({ page }: MobileAppWebViewLayoutProps) => {
    return <>{page}</>;
};
